import React from "react";
import { useMediaQuery, Box, Fade } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import EnhancedAgencyRosterDesktop from "../rosterComps/agencyRosterDesktop";
import AgencyRosterMobileSettings from "../rosterComps/agencyRosterMobile"; // Use the new mobile component

export default function AgencyRosterSettings() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));

  React.useEffect(() => {
    const deviceType = isMobile ? 'mobile' : isTablet ? 'tablet' : 'desktop';
    console.log(`Agency Roster Settings loaded for: ${deviceType}`);
  }, [isMobile, isTablet, isDesktop]);

  return (
    <Box sx={{ minHeight: '100vh' }}>
      {isMobile ? (
        <Fade in key="mobile" timeout={300}>
          <div>
            <AgencyRosterMobileSettings />
          </div>
        </Fade>
      ) : (
        <Fade in key="desktop" timeout={300}>
          <div>
            <EnhancedAgencyRosterDesktop />
          </div>
        </Fade>
      )}
    </Box>
  );
}